import { useEffect, useState } from 'react';

import ProgressBar from './ProgressBar';
import CampaignStatus from './CampaignStatus';
import DonateNow from './DonateNow';

const config = require('../fundraiser-config');
const { match } = config;

const CampaignInfo = () => {
    const [donatedAmount, setDonatedAmount] = useState("N/A");
    const [donationGoal, setDonationGoal] = useState("N/A");
    const [percentageFilled, setPercentageFilled] = useState(0); // [0, 100]
    const [donors, setDonors] = useState(0);

    useEffect(() => {
        fetch(config.urls.campaign, {
            "headers": {
                "accept": "application/json, text/plain, */*",
                "accept-language": "en-US,en;q=0.7",
                "sec-fetch-dest": "empty",
                "sec-fetch-mode": "cors",
                "sec-fetch-site": "same-site",
                "sec-gpc": "1"
            },
            "referrer": "https://campaigns.tithely.com/",
            "referrerPolicy": "strict-origin-when-cross-origin",
            "method": "GET",
            "mode": "cors",
            "credentials": "omit"
        })
            .then(res => res.json())
            .then(data => {
                let { goal_amount, total_pledged, num_donors, percent_pledged } = data.data;

                total_pledged += config.override.donated * 100;
                num_donors += config.override.donors;

                // Match up to $10,000
                if (total_pledged > match * 100) total_pledged += match * 100;
                else total_pledged *= 2;

                percent_pledged = (total_pledged / goal_amount) * 100;

                setDonatedAmount(`$${(total_pledged / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
                setDonationGoal(`$${(goal_amount / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);
                setPercentageFilled(percent_pledged);
                setDonors(num_donors.toLocaleString());
            });
    }, []);

    return (
        <div className="bg-gray-200 w-11/12 rounded-lg relative bottom-10 z-10 flex flex-col justify-center items-center p-5 text-center">
            <h1 className="text-2xl font-bold mb-2">{config.title}</h1>
            <p className="text-base mb-2.5 text-gray-700">{config.subtitle}</p>
            <hr className="bg-gray-500 w-4/5 h-0.5 mt-2.5 mb-2.5" />
            <ProgressBar percentageFilled={percentageFilled} />
            <CampaignStatus donatedAmount={donatedAmount} donationGoal={donationGoal} donors={donors} />
            <DonateNow />
        </div>
    )
};

export default CampaignInfo;